
import { useIntercom } from 'react-use-intercom';
import React, { createContext, useEffect, useState, memo } from 'react';

export const IntercomControlContext = createContext();

const IntercomSetup = memo(({ enabled, children }) => {
  const { boot, shutdown } = useIntercom();
    
  useEffect(() => {
    if (enabled) {
      boot({
        alignment: 'right',
        horizontal_padding: 20,
        vertical_padding: 20,
      });
      
      return () => {
        shutdown();
      };
    } else {
      shutdown();
    }
  }, [enabled, boot, shutdown]);

  return <>{children}</>;
});

const IntercomControlProvider = ({ children, isEnabled = false}) => {
  const isInitialMount = React.useRef(true);
  const [enabled, setEnabled] = useState(isEnabled);
  
  const updateEnabled = (newValue) => {
    if (newValue !== enabled) {
      setEnabled(newValue);
    }
  };

  useEffect(() => {
    isInitialMount.current = false;
  }, []);

  return (
    <IntercomControlContext.Provider value={{ enabled, setEnabled: updateEnabled }}>
      <IntercomSetup enabled={enabled}>
        {children}
      </IntercomSetup>
    </IntercomControlContext.Provider>
  );
};

export default IntercomControlProvider;